import React from 'react'
import PropTypes from "prop-types"
import classnames from 'classnames/bind'

import Badge from 'js/components/shared/Badge'

import styles from './ItemsColumns.module.scss'

const cx = classnames.bind(styles)

const ItemsColumns = ({ items = [] }) => (
  <div className={cx('columns')}>
    <div className={cx('column', 'column-1')}>
      {items?.slice(0, 3)?.map((item) => getColumnContent(item))}
    </div>
    <div className={cx('column', 'column-2')}>
      {items?.slice(3, 6)?.map((item) => getColumnContent(item))}
    </div>
    <div className={cx('column', 'column-3')}>
      {items?.slice(6)?.map((item) => getColumnContent(item))}
    </div>
  </div>
)

function getColumnContent(data) {
  return (
    (<div className={cx('item')} key={data.id}>
      <h4
        className={cx('item-title')}>
        {data?.icon && (<i className={`icon-${data?.icon}`} aria-hidden={true} />)}
        {data?.label}
        {data.paying && (
          <Badge className={cx('paying')} color="gray" theme="semi-round">{data.paying}</Badge>
        )}
      </h4>
      {!!data?.facilities?.length && (
        <ul className={cx('item-list')}>
          {data.facilities.map((f, i) => (
            <li className={cx('item-list-entry')} key={i}>
              {f?.name}{f?.additionalText ? ` ${f?.additionalText}` : ''}
              {!!f?.paying?.length && (
                <Badge className={cx('paying')} color="gray" theme="semi-round">{f.paying}</Badge>
              )}
              {!!f?.list?.length && (
                <ul className={cx('entry-sublist')}>
                  {f.list.map((sub, i) => (
                    <li className={cx('entry-sublist-item')} key={i}>
                      {sub.name}
                      {sub.paying && (
                        <Badge className={cx('paying')} color="gray" theme="semi-round">{sub.paying}</Badge>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>)
  )
}

ItemsColumns.propTypes = {
  items: PropTypes.array,
}

export default ItemsColumns
